/** In-memory query strings per Reputation tab, restored when returning to that tab. */
export const reputationTabSearchMemory: Record<"overview" | "reviews", string> = {
  overview: "",
  reviews: "",
};
